import ForgotPasswordForm from "features/auth/ForgotPasswordForm";
import ResetPasswordForm from "features/auth/ResetPasswordForm";
import VerifyEmailChangeForm from "features/auth/VerifyEmailChangeForm";
import PublicLayout from "layouts/PublicLayout";
import Login from "pages/login/Login";
import { Navigate, Route, Routes } from "react-router-dom";

export default function PublicRouter() {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout />}>
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPasswordForm />} />
        <Route path="reset-password" element={<ResetPasswordForm />} />
        <Route path="verify-email-change" element={<VerifyEmailChangeForm />} />
        <Route path="" element={<Navigate to="login" />} />
        <Route path="*" element={<Navigate to="login" />} />
      </Route>
    </Routes>
  );
}
